import { render, staticRenderFns } from "./signSuccess.vue?vue&type=template&id=8be5c768&scoped=true"
import script from "./signSuccess.vue?vue&type=script&lang=js"
export * from "./signSuccess.vue?vue&type=script&lang=js"
import style0 from "./signSuccess.vue?vue&type=style&index=0&id=8be5c768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be5c768",
  null
  
)

export default component.exports